import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoClock = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Clock</title>
    <path
      d="M27.57 16.991c0 6.391-5.18 11.572-11.57 11.572-6.392 0-11.572-5.18-11.572-11.572 0-6.39 5.18-11.571 11.571-11.571 6.39 0 11.572 5.18 11.572 11.571Z"
      stroke="currentColor"
      strokeWidth={2}
    />
    <path
      d="m20.04 21.031-3.706-3.705a1.143 1.143 0 0 1-.335-.808V9.563"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
export default SvgIcoClock;
